import { Stage } from '@eventbrite/webapp-constants';
import { CORE_HOSTS } from '@/src/homepage/constants/coreHosts';

export const SUPPORTED_LOCALE_PATHS: Record<string, string[]> = {
    ca: ['fr_CA'],
    be: ['fr_BE', 'nl_BE'],
    ch: ['fr_CH', 'de_CH'],
};

export function normalizeTld(tld: string | undefined): string {
    return tld?.replace(/^\./, '') || 'com';
}

export function isDualLanguageTLD(tld: string | undefined): boolean {
    const normalized = normalizeTld(tld);
    return normalized in SUPPORTED_LOCALE_PATHS;
}

export interface HreflangLink {
    domain: string;
    locale?: string;
    path?: string; // path like /fr_CA/
    hreflang: string;
}

export const HREFLANG_LINKS: HreflangLink[] = [
    { domain: 'com', hreflang: 'en-us' },
    { domain: 'ca', hreflang: 'en-ca' },
    { domain: 'ca', locale: 'fr_CA', path: '/fr_CA/', hreflang: 'fr-ca' },
    { domain: 'com.ar', hreflang: 'es-ar' },
    { domain: 'com.br', hreflang: 'pt-br' },
    { domain: 'cl', hreflang: 'es-cl' },
    { domain: 'com.mx', hreflang: 'es-mx' },
    { domain: 'com.pe', hreflang: 'es-pe' },
    { domain: 'co', hreflang: 'es-co' },
    { domain: 'co.uk', hreflang: 'en-gb' },
    { domain: 'ie', hreflang: 'en-ie' },
    { domain: 'de', hreflang: 'de-de' },
    { domain: 'at', hreflang: 'de-at' },
    { domain: 'nl', hreflang: 'nl-nl' },
    { domain: 'be', hreflang: 'nl-be' },
    { domain: 'es', hreflang: 'es-es' },
    { domain: 'fr', hreflang: 'fr-fr' },
    { domain: 'be', locale: 'fr_BE', path: '/fr_BE/', hreflang: 'fr-be' },
    { domain: 'it', hreflang: 'it-it' },
    { domain: 'pt', hreflang: 'pt-pt' },
    { domain: 'se', hreflang: 'sv-se' },
    { domain: 'com.au', hreflang: 'en-au' },
    { domain: 'co.nz', hreflang: 'en-nz' },
    { domain: 'sg', hreflang: 'en-sg' },
    { domain: 'hk', hreflang: 'en-hk' },
    { domain: 'dk', hreflang: 'en-dk' },
    { domain: 'fi', hreflang: 'en-fi' },
    { domain: 'ch', hreflang: 'de-ch' },
    { domain: 'ch', locale: 'fr_CH', path: '/fr_CH/', hreflang: 'fr-ch' },
    { domain: 'com', hreflang: 'x-default' }, // x-default should point to main domain
];

export function isLocalePathSupported(tld: string, locale: string): boolean {
    const supportedLocales = SUPPORTED_LOCALE_PATHS[tld];
    return supportedLocales ? supportedLocales.includes(locale) : false;
}

export function getHreflangLinks(stage: Stage): Array<{ href: string; hreflang: string }> {
    const baseHost = CORE_HOSTS[stage];

    return HREFLANG_LINKS.map((link) => {
        const domain = `www.${baseHost === 'eventbrite.com' ? 'eventbrite' : baseHost.split('.')[0]}.${link.domain}`;
        const path = link.path || '/';
        const href = `https://${domain}${path}`;

        return {
            href,
            hreflang: link.hreflang,
        };
    });
}
